module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nofundcontain"
  }, [_c('div', {
    staticClass: "nofund_container"
  }, [_c('h1', [_vm._v("对不起，您访问的页面不存在！")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c6825b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/404.vue
// module id = 1231
// module chunks = 2